import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { default as constantsFile } from '@app/shared/constants.json';

@Component({
    selector: 'app-landing',
    templateUrl: './landing.component.html',
    styleUrls: ['./landing.component.scss'],
    standalone: false
})
export class LandingComponent implements OnInit {

  public browserMessage: string;
  constants: any = constantsFile.constants;

  constructor(
    private modal: NgbModal
  ) { }

  ngOnInit() {
    // Current language is set.
    // this.setLanguage(this.currentLanguage);

    localStorage.setItem('airlineContract', "");
    localStorage.setItem('countryContract', "");

    const userAgent = navigator.userAgent,
    M = userAgent.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
    if(navigator.appName == 'Microsoft Internet Explorer' || navigator.appName == "Netscape" && navigator.appVersion.indexOf('Trident') !== -1){
      /// in IE 11 the navigator.appVersion says 'trident'
      /// in Edge the navigator.appVersion does not say trident
      this.browserMessage = "Not Supported Browser";
    } else if(M[1] && M[1].toLowerCase() != this.constants.navigators.chrome && M[1].toLowerCase() != this.constants.navigators.firefox){
      //// El navegador no será ni Explorer (no recomendado), ni Chrome o Firefox (recomendados)
      this.browserMessage = "Not Recommended Browser";
    } else if(M[1] && M[1].toLowerCase() == this.constants.navigators.chrome){
      const body = document.getElementById('main-tag');
      body.classList.add('h-complete');
    } else if(M[1] && M[1].toLowerCase() == this.constants.navigators.firefox){
      const body = document.getElementById('page-top');
      body.classList.add('h-inherit');
    }
  }

  openLogin(modalid: string) {
    this.modal.open(modalid);
  }

  public moveOnPage(destino: string) {
    const dest = document.querySelector(destino);
    dest.scrollIntoView({ behavior: "smooth" });
  }

  // setLanguage(language: string) {
  //   localStorage.setItem("language", language);
  //   this.sharedDataService.updateLanguage();
  //   this.translateService.use(language);
  // }

  // get currentLanguage(): string {
  //   return this.translateService.currentLang;
  // }
  //
  // get languages(): string[] {
  //   return this.translateService.langs;
  // }

  ngOnDestroy() {
    const body = document.getElementById('page-top');
    body.classList.remove('h-inherit');
  }

}
